export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9999.9ac54178.jpg";